import React from 'react'
import { Typography, Tabs, Card, Row, Col } from 'antd'
import { AppstoreOutlined, CheckCircleOutlined, ApiOutlined, CloudServerOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import './Dashboard.css'
import ApplicationSelector from '../components/ApplicationSelector'
import ApplicationDetails from '../features/application/ApplicationDetails'
import DependenciesView from '../features/dependencies/DependenciesView'
import DatabaseDetails from '../features/database/DatabaseDetails'
import JobDetails from '../features/jobs/JobDetails'
import ServiceDetails from '../features/services/ServiceDetails'
import PipelineDetails from '../features/pipeline/PipelineDetails'
import MainLayout from '../components/MainLayout'

const { Title } = Typography

const Dashboard = () => {
  const { applications, selectedApplication, applicationDetails } = useSelector((state) => state.application)
  const { jobs = [] } = useSelector((state) => state.jobs)
  const { services = [] } = useSelector((state) => state.services)

  const activeJobsCount = (jobs || []).filter(job => job.status === 'Active' || job.isActive).length
  const activeServicesCount = (services || []).filter(service => service.status === 'Active' || service.status === 'Running').length
  
  const selectedAppName = applicationDetails?.applicationName || ''

  const tabItems = [
    {
      key: 'details',
      label: 'Application Details',
      children: (
        <Card bordered style={{ borderColor: '#d9d9d9', borderWidth: '1px' }}>
          <ApplicationDetails />
        </Card>
      ),
    },
    {
      key: 'dependencies',
      label: 'Dependencies',
      children: (
        <Card bordered style={{ borderColor: '#d9d9d9', borderWidth: '1px' }}>
          <DependenciesView />
        </Card>
      ),
    },
    {
      key: 'database',
      label: 'Database',
      children: (
        <Card bordered style={{ borderColor: '#d9d9d9', borderWidth: '1px' }}>
          <DatabaseDetails />
        </Card>
      ),
    },
    {
      key: 'jobs',
      label: 'Jobs',
      children: (
        <Card bordered style={{ borderColor: '#d9d9d9', borderWidth: '1px' }}>
          <JobDetails />
        </Card>
      ),
    },
    {
      key: 'services',
      label: 'Services',
      children: (
        <Card bordered style={{ borderColor: '#d9d9d9', borderWidth: '1px' }}>
          <ServiceDetails />
        </Card>
      ),
    },
    {
      key: 'pipelines',
      label: 'Pipelines',
      children: (
        <Card bordered style={{ borderColor: '#d9d9d9', borderWidth: '1px' }}>
          <PipelineDetails />
        </Card>
      ),
    },
  ]

  const SummaryCards = () => (
    <Row gutter={16}>
      <Col xs={24} sm={12} md={8}>
        <Card 
          style={{ 
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            marginBottom: '16px',
            padding: '8px',
          }}
          bodyStyle={{ padding: '12px' }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <AppstoreOutlined style={{ fontSize: '24px', color: '#1890ff' }} />
            <div>
              <div style={{ fontSize: '12px', color: '#666', marginBottom: '2px' }}>
                Total Applications
              </div>
              <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#000' }}>
                {applications.length}
              </div>
            </div>
          </div>
        </Card>
      </Col>
      <Col xs={24} sm={12} md={8}>
        <Card 
          style={{ 
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            marginBottom: '16px',
            padding: '8px',
          }}
          bodyStyle={{ padding: '12px' }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <CheckCircleOutlined style={{ fontSize: '24px', color: '#52c41a' }} />
            <div>
              <div style={{ fontSize: '12px', color: '#666', marginBottom: '2px' }}>
                Active Jobs
              </div>
              <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#000' }}>
                {activeJobsCount}
              </div>
            </div>
          </div>
        </Card>
      </Col>
      <Col xs={24} sm={12} md={8}>
        <Card 
          style={{ 
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            marginBottom: '16px',
            padding: '8px',
          }}
          bodyStyle={{ padding: '12px' }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <CloudServerOutlined style={{ fontSize: '24px', color: '#13c2c2' }} />
            <div>
              <div style={{ fontSize: '12px', color: '#666', marginBottom: '2px' }}>
                Active Services
              </div>
              <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#000' }}>
                {activeServicesCount}
              </div>
            </div>
          </div>
        </Card>
      </Col>
    </Row>
  )

  return (
    <MainLayout>
      <ApplicationSelector summaryCards={<SummaryCards />} />

      <Card 
        style={{ 
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
      >
        <Tabs 
          defaultActiveKey="details" 
          items={tabItems}
          className="dashboard-tabs"
        />
      </Card>
    </MainLayout>
  )
}

export default Dashboard
